<div
  class="container-fluid font-responsive"
  [ngClass]="{ 'p-0': mobileMode(), 'h-100': mobileMode() }"
  style="position: relative"
  [style.background-color]="clozeTestStyleModel().siteBackground">
  <div class="d-flex justify-content-center" [ngClass]="{ 'h-100': mobileMode() }">
    <div
      class="card"
      [ngClass]="{ 'container-fluid': mobileMode(), 'p-0': mobileMode() }"
      style="min-height: 570px"
      [style.background-color]="clozeTestStyleModel().exerciseBackground"
      [ngStyle]="{
        border: mobileMode() ? '0px' : '1px solid ' + clozeTestStyleModel().frameColor,
        'border-radius': mobileMode() ? '0px' : '0.25rem',
        width: mobileMode() ? '' : '720px',
      }">
      <div
        class="card-body"
        [ngClass]="{ 'card-mobile': mobileMode() }"
        [style.font-family]="clozeTestStyleModel().font"
        [style.font-size]="clozeTestStyleModel().fontSize"
        style="overflow-y: scroll">
        <div>
          <img alt="Onset Logo" style="height: 30px" src="onset-assets/img/onset_logo.png" />
          <img alt="Ger Onset Logo" style="height: 40px" class="ml-4" src="onset-assets/img/icon_ger_onset.svg" />
        </div>
        <h5 class="card-title font-weight-bold mt-4" style="font-size: 1rem !important">
          {{ "GAST-ONSET-NG.GER_INFO.TITLE" | translate }}
        </h5>
        <p>
          {{ "GAST-ONSET-NG.GER_INFO.DESC_1" | translate }}
        </p>

        <p>
          {{ "GAST-ONSET-NG.GER_INFO.DESC_2" | translate }}
        </p>

        <img alt="Mobile logo" style="height: 60%" src="onset-assets/img/GER_onSET_mobil.svg" />

        <p class="mt-4">
          {{ "GAST-ONSET-NG.GER_INFO.DESC_3" | translate }}
        </p>

        <span
          ><a style="text-decoration: underline" href="https://www.onset.de/">{{
            "GAST-ONSET-NG.GER_INFO.BACK" | translate
          }}</a
          >{{ "GAST-ONSET-NG.GER_INFO.TO_ONSET" | translate }}</span
        >
      </div>
    </div>
  </div>
</div>
